import type { Match, MatchTable } from "./matching.ts";
import { createMatchTable } from "./matching.ts";

export enum Op {
  // args: wordIndex:byte, stack: 0 -> 1
  Match = 0,
  // stack: 2 -> 1
  Or = 1,
  // stack: 2 -> 1
  And = 2,
}

// Note: this is compatible (a subtype of) StoredExpression in storedFormat.ts
export type Expression =
  | { op: Op.Match; match: Match; word: string }
  | { op: Op.Or | Op.And; left: Expression; right: Expression };

function expressionWords(expr: Expression): string[] {
  if (expr.op === Op.Match) {
    return [expr.word];
  }
  return [...expressionWords(expr.left), ...expressionWords(expr.right)];
}

export function createExpressionMatchTable(expr: Expression) {
  return createMatchTable(expressionWords(expr));
}

export function testExpression(expr: Expression, matches: MatchTable): boolean {
  switch (expr.op) {
    case Op.Match: {
      const wordMatch = matches.get(expr.word);
      if (typeof wordMatch === "undefined") {
        throw new Error(`Match table does not contain word: ${expr.word}`);
      }
      return wordMatch >= expr.match;
    }
    case Op.Or:
      return testExpression(expr.left, matches) || testExpression(expr.right, matches);
    case Op.And:
      return testExpression(expr.left, matches) && testExpression(expr.right, matches);
  }
}
